import { useQuery } from '@tanstack/react-query';
import {
   getCourseAssignmentUserCompletionFromClient,
   GetCourseAssignmentUserCompletionErrorCode,
} from '~/pages/api/courses/view/assignees/getCourseAssignmentUserCompletion.api';
import { useLocalization } from '~/framework';
import { useApiErrorMessageToast } from '~/pages/_shared';

const KEY = 'course-assignment-user-completion';

export function getCourseAssignmentUserCompletionKey() {
   return [KEY];
}

export function useCourseAssignmentUserCompletion(wikiid: number, userid: number) {
   const { _js } = useLocalization();
   const { handleErrorOrRedirectToLogin } =
      useApiErrorMessageToast<GetCourseAssignmentUserCompletionErrorCode>({
         'courses.course_assignment_user_completion_not_found': _js(
            'Could not find use course assignment completion'
         ),
         default: _js(
            'There was a problem retrieving the selected user course assignment completion'
         ),
      });

   const queryFunction = async () => {
      return await getCourseAssignmentUserCompletionFromClient(wikiid, userid);
   };

   return useQuery({
      queryFn: queryFunction,
      queryKey: [KEY, wikiid, userid],
      onError: handleErrorOrRedirectToLogin,
   });
}
